import { Component, ElementRef, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { ChatService } from '../../core/services/chat.service';
import { WalletService } from '../../core/services/wallet.service';
import { ChatMessage, ChatUser } from 'shared-types';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-chat-window',
  standalone: true,
  template: `
    <div class="chat-container">
      <div class="chat-left">
        <div class="chat-messages" #messagesRef (scroll)="onChatScroll()">
          @for (m of chatMessages; track m.id) {
          <div class="chat-message">
            <span class="chat-user">{{ m.user }}</span>
            <span class="chat-text">{{ m.text }}</span>
          </div>
          }
        </div>
        <div class="chat-input-bar">
          <input
            #inputRef
            type="text"
            [(ngModel)]="chatInput"
            (keydown.enter)="sendChatMessage()"
            placeholder="Type a message..."
          />
          <button class="connect-wallet-btn" (click)="sendChatMessage()">Send</button>
        </div>
      </div>
      <div class="chat-right">
        <div class="users-header">Active Users ({{ chatUsers.length }})</div>
        <div class="users-list">
          @for (u of chatUsers; track u.username) {
          <div class="user-item">{{ u.username }}</div>
          }
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./chat.component.scss'],
  imports: [FormsModule],
})
export class ChatComponent implements OnInit, OnDestroy {
  private readonly chatService = inject(ChatService);
  private readonly walletService = inject(WalletService);

  chatMessages: ChatMessage[] = [];
  chatUsers: ChatUser[] = [];
  chatInput = '';
  chatAutoScroll = true;

  @ViewChild('messagesRef') messagesRef?: ElementRef<HTMLDivElement>;
  @ViewChild('inputRef') inputRef?: ElementRef<HTMLInputElement>;

  ngOnInit(): void {
    const username = this.walletService.walletConnection()?.actor || 'Guest';
    this.chatService.connect(username);
    this.chatService.messages$.subscribe((msgs) => {
      this.chatMessages = msgs;
      if (this.chatAutoScroll) setTimeout(() => this.scrollChatToBottom(), 0);
    });
    this.chatService.users$.subscribe((users) => (this.chatUsers = users));
    setTimeout(() => this.inputRef?.nativeElement?.focus(), 0);
  }

  ngOnDestroy(): void {
    this.chatService.disconnect();
  }

  sendChatMessage() {
    const text = this.chatInput.trim();
    if (!text) return;
    this.chatService.send(text);
    this.chatInput = '';
    setTimeout(() => this.scrollChatToBottom(), 0);
  }

  onChatScroll() {
    const el = this.messagesRef?.nativeElement;
    if (!el) return;
    const threshold = 4;
    this.chatAutoScroll = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
  }

  private scrollChatToBottom() {
    const el = this.messagesRef?.nativeElement;
    if (!el) return;
    el.scrollTop = el.scrollHeight;
  }
}
